import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setupMorphHandlers()
  }

  disconnect() {
    this.removeMorphHandlers()
  }

  setupMorphHandlers() {
    // Listen for morph finish events
    document.addEventListener('turbo:morph', this.handleMorph.bind(this))
    document.addEventListener('turbo:render', this.restoreFocus.bind(this))
  }

  removeMorphHandlers() {
    document.removeEventListener('turbo:morph', this.handleMorph.bind(this))
    document.removeEventListener('turbo:render', this.restoreFocus.bind(this))
  }

  handleMorph(event) {
    // Store any active element data before morphing
    if (document.activeElement) {
      const activeElement = document.activeElement
      
      if (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.tagName === 'SELECT') {
        this.focusData = {
          id: activeElement.id,
          value: activeElement.value,
          position: activeElement.selectionStart,
          element: activeElement
        }
      }
    }
  }

  restoreFocus() {
    // After rendering, try to restore focus state
    if (this.focusData && this.focusData.id) {
      // Find the element by ID
      const element = document.getElementById(this.focusData.id)
      
      if (element) {
        // Restore focus
        element.focus()
        
        // For inputs and textareas, restore cursor position
        if ((element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') && 
             typeof this.focusData.position === 'number') {
          element.setSelectionRange(this.focusData.position, this.focusData.position)
        }
      }
      
      // Clear stored focus data
      this.focusData = null
    }
  }
} 
